import { useNavigate } from "react-router";

export default function useNav() {
  const navigate = useNavigate();

  const navigateWithLog = (path: string) => {
    console.log("Navigating to:", path);
    return navigate(path);
  };

  return navigateWithLog;
}
